module.exports = __webpack_public_path__ + "static/media/promo-banner-tablet.89eb089e.jpg";